import { RestRequest, RestContext, ResponseFunction } from 'msw'
import {
  addToEntityListData,
  updateEntityListData,
  deleteEntityListData,
} from '../../../modules/mockDataCommon'
import { requireAuthenticatedUser } from '../../../decorators'
import { getLocationTypeListData } from './mockData'
import type { ILocationType } from '@/types/location/models'

// get

interface GetLocationTypesResponse {
  data: ILocationType[]
}

async function getLocationTypes(
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) {
  const responseBody: GetLocationTypesResponse = {
    data: await getLocationTypeListData(),
  }
  return res(ctx.status(200), ctx.json(responseBody))
}

// post

const postLocationType = async (
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) => {
  return addToEntityListData(req, res, ctx, getLocationTypeListData)
}

const patchLocationType = async (
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) => {
  return updateEntityListData(req, res, ctx, getLocationTypeListData)
}

const deleteLocationType = async (
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) => {
  return deleteEntityListData(req, res, ctx, getLocationTypeListData)
}

export const handlers = [
  {
    method: 'get',
    path: '/api/locationtypes',
    handler: getLocationTypes,
  },
  {
    method: 'post',
    path: '/api/locationtypes',
    handler: postLocationType,
  },
  {
    method: 'patch',
    path: '/api/locationtypes/:id',
    handler: patchLocationType,
  },
  {
    method: 'delete',
    path: '/api/locationtypes/:id',
    handler: deleteLocationType,
  },
].map((h) => ({ ...h, ...{ handler: requireAuthenticatedUser(h.handler) } }))
